import { useCallback } from "react";
import { useLanguage } from "@/contexts/LanguageContext";

/**
 * Prefix a public-site path with the active language segment.
 *   useLocalizedPath()("/about") -> "/en/about" when lang=en
 *   useLocalizedPath()("/")      -> "/en"
 * Pass already-prefixed paths through unchanged.
 */
export const useLocalizedPath = () => {
    const { lang } = useLanguage();
    return useCallback(
        (path: string): string => {
            if (!path || path === "/") return `/${lang}`;
            if (path.startsWith(`/${lang}/`) || path === `/${lang}`) return path;
            if (path.startsWith("#")) return path;
            if (path.startsWith("/")) return `/${lang}${path}`;
            return path;
        },
        [lang],
    );
};
